<div class="row justify-content-center px-3" *ngIf="!props.isVisible">
  <!-- <div class="d-flex justify-content-between" *ngIf="props.formtype === 'addfirst'">
    <div class="text-capitalize">Achievements</div>
    <button class="btn plus-icon" type="button" (click)="addFieldValue()"></button>
  </div> -->
<!-- 
  <div class="cedits-heading" *ngIf="props.field_Name === 'studentAchievementDetails'">
    
  </div> -->
  <div class="mb-2">
    <fieldset [ngClass]="{'border rounded-3 p-3': props.field_Name === 'loc' || props.field_Name === 'mentor'}">
      <legend
        *ngIf="props.field_Name !== 'categories' && props.field_Name !== 'options' && props.field_Name !== 'cat' && props.field_Name !== 'questions' && props.field_Name !== 'timeline'"
        class="float-none w-auto">
        {{props.label}}
      </legend>
      <div *ngFor="let form of fieldArray; let i = index">
        <form [formGroup]="form">
          <div class="form-group row align-items-end  mt-3 "
            [ngClass]="{'justify-content-start mt-0': props.field_Name === 'categories' || props.field_Name === 'options'}">
            <ng-container *ngFor="let field of formFields; let index = index">
              <ng-container *ngIf="evaluate(field, i, form)">
                <div class="{{ field.initClass }}">
                  <sm-input [props]="field" formControlName="{{ field.field_Name }}" *ngIf="field.fieldType === 'input'"
                    (InputAction)="initInputAction($event, field.field_Name)"
                    (input)="setValue(form, $event, i, field.fieldType, field.field_Name)"></sm-input>
                    
                  <sm-select [props]="field" [options]="field.options" formControlName="{{ field.field_Name }}"
                    *ngIf="field.fieldType === 'select'" (selected)="setValue(form, $event, i, field)" ></sm-select>
                  <!-- <sm-textarea [props]="field" formControlName="{{ field.field_Name }}" *ngIf="field.fieldType === 'textarea'" (input)="setValue(form, $event, i, field.fieldType)"></-textarea> -->
                  <sm-checkbox [props]="field" formControlName="{{ field.field_Name }}"
                    *ngIf="field.fieldType === 'checkbox'"
                    (checked)="setValue(form, $event, i, field.fieldType)"></sm-checkbox>
                    
                  <sm-datetimepicker [props]="field" formControlName="{{ field.field_Name }}"
                    *ngIf="field.fieldType === 'datepicker'"
                    (date)="setValue(form, $event, i, field.fieldType)"></sm-datetimepicker>
                  <sm-simple-textarea [props]="field" formControlName="{{ field.field_Name }}"
                    *ngIf="field.fieldType === 'SimpleTextarea'"
                    (checked)="setValue(form, $event, i, field.fieldType)"></sm-simple-textarea>
                  <!-- <sm-file [props]="field" [Form]="form" formControlName="{{ field.field_Name }}"
                    [editModel]="{ data: EditModel[i + (page.pageNumber - 1) * page.pageSize], meta: field }"
                    *ngIf="field.fieldType === 'file'" (fileDeleted)="deleteFilePopup($event)"></sm-file> -->



                  <sm-sub-form [props]="field" formControlName="{{ field.field_Name }}"
                    *ngIf="field.fieldType === 'dynamicform'" [Form]="form" [EditModel]="EditModel[0][field.field_Name]"
                    (smdynamic)="setValue(form, $event, i, field)"></sm-sub-form>
                </div>
              </ng-container>

              
            </ng-container>
            <!-- <i class="btn" [ngClass]="{'plus-icon-types':props.field_Name === 'cat'}" type="button" (click)="addFieldValue()">
            <img src="../../../../assets/images/plus-outline.svg" alt="plus-icon">
            </i> -->
            <span class=" col-1 mb-4" type="button" (click)="deleteFieldValue(i, form)"
              *ngIf="fieldArray.length > 1  && props.field_Name === 'studentAchievementDetails'">
              X
            </span>
            <span class=" col-1 mb-4" type="button" (click)="deleteFieldValue(i, form)"
              *ngIf="fieldArray.length > 1 && (props.field_Name === 'options' || props.field_Name === 'categories' || props.field_Name === 'cat')">
              <i class="delete-red"></i>
            </span>
            <div class="d-flex justify-content-end align-items-end">
              <button class=" btn btn-primary " type="button" (click)="deleteFieldValue(i, form)"
                *ngIf="fieldArray.length > 1  && props.field_Name === 'questions'">
                Remove Question
              </button>
              <button class=" btn btn-primary " type="button" (click)="deleteFieldValue(i, form)"
                *ngIf="fieldArray.length > 1  && props.field_Name === 'timeline'">
                Remove Timeline
              </button>
            </div>
          </div>
        </form>
      </div>

      <!-- <ng-container
      *ngIf="col.isToggle && props.field_Name !== 'cat' "
    >
      <div class="form-check form-switch mx-3">
        <input
          class="form-check-input color-check"
          type="checkbox"
          role="switch"
          id="flexSwitchCheckDefault"
          [checked]="row['attended_flag'] === '1'"
          (click)="
            row['attended_flag'] === '1'
              ? (row['attended_flag'] = '0')
              : (row['attended_flag'] = '1');
            openConfirmationStatusPopup(row)
          "
        />
      </div>
    </ng-container> -->

      <button class="btn btn-primary " type="button" (click)="addFieldValue()"  *ngIf= "props.field_Name !== 'cat'" 
        style="font-size: 12px">{{props.label.includes('Add') ? props.label :'Add ' + props.label}}</button>


        
      <div class=" d-flex justify-content-start col-md-12 col-lg-12 col-sm-12 col-xs-12"
        *ngIf="fieldArray.length>5 && props.formtype === 'addfirst'">
        <pagination [totalItems]="fieldArray.length" [itemsPerPage]="page.pageSize" [(ngModel)]="page.pageNumber"
          [ngModelOptions]="{standalone: true}" [maxSize]="page.maxSize" class="pagination-sm" [boundaryLinks]="true"
          [rotate]="false" (pageChanged)="onPageChange($event)"></pagination>
      </div>
    </fieldset>
    <!-- <sm-error [control]="formcontrol"></sm-error> -->
    <sm-error [control]="formcontrol" [label]="props.label"></sm-error>


  </div>
  



  <!-- <ng-template #deleteFile let-c="close" let-d="dismiss">
    <div class="modal-content" style="border: none;">
      <div class="modal-header preview-header py-2 px-0">
        <h4 class="modal-title preview-title" id="modal-basic-title">Confirmation</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>
      <div class="modal-body d-flex flex-column p-2">
        <div>Do you want to delete the selected Achievement?</div>
        <div class="d-flex justify-content-end align-items-right py-4">
          <button type="button" (click)="deleteUploadedFile()" class="btn btn-primary fuse-ripple-ready">
            Save
          </button>
          &nbsp;
          <button type="button" (click)="d('Cross click')" class="btn btn-default mx-2 fuse-ripple-ready">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </ng-template> -->